import Vue from 'vue'
import VtLoading from '@/components/common/VtLoading.vue'
Vue.component('VtLoading', VtLoading)
